export enum E_KHATTABAT_ONE_O_TWO_MESSAGE_HISTORY_EVENT_TYPE {
  ADDED = "added",
  CHANGED = "changed",
  REMOVED = "removed"
}
